import {
	ClientsAndCompaniesState,
	StoreAction,
} from '../../interfaces/redux.interface';
import * as ClientsAndCompanyActions from '../constants/workingTime';

const initialState: ClientsAndCompaniesState = {
	data: {},
};

const clientsCompaniesReducer = (
	state: typeof initialState = initialState,
	action: StoreAction<any>,
): ClientsAndCompaniesState => {
	switch (action.type) {
		case ClientsAndCompanyActions.GET_CLIENTS_COMPANIES_SUCCESS:
			return {
				...state,
				data: action.payload,
			};
		default:
			return state;
	}
};

export default clientsCompaniesReducer;
